/**
 @description: description
 @date: 2018/4/8
 @author: 雷利(Rayleight@baie.com.cn)
 */
import Cookies from 'js-cookie'
import {Platform} from 'react-native'
import * as qs from 'qs'
// eslint-disable-next-line
import packageInfo from '../../package.json'

import {logout} from '../actions/UserInfo'
import {setIPayInfo} from '../actions/IPayInfo'
import {store} from '../index'
import {getValue} from '../project_config/index'
import {
    NEW_WALLET_INFO_QUERY,
    USER_INFO,
    MARKETER_USERINFO_GET, // 获取星探登记信息
    USER_WALLET_INFO,
    MARKETER_WSTEAM_GET,
    USERSERVICETAG_GET,
    I_GET_EPITHID,
    LOGOUT_URL,
    ORDER_WEB_ORDERS_PAYMENT_SIGN
} from '../constants/FetchUrls'
import {identify} from './ZGTools'
import {getMainDomain, isRightToken, R_alert} from './index'
import {getTokenCookieOptions} from './tokenCookie'
import {captureException, setSentryTag, setSentryUser, traceResponseError} from './sentry'

window.global = window.global || window
const TIMEOUT = 60 * 1000
const USER_AGENT_IOS = `Mozilla/5.0 (iPhone; CPU iPhone OS 9_1 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13B143 Safari/601.1 BaiE_APP V${packageInfo.version}`
const USER_AGENT_ANDROID = `Mozilla/5.0 (Linux; Android 6.0.1; SM-C7000 Build/MMB29M; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/55.0.2883.91 Mobile Safari/537.36 Language/zh_CN BaiE_APP V${packageInfo.version}`

export const USER_AGENT = Platform.OS === 'ios' ? USER_AGENT_IOS : USER_AGENT_ANDROID
const EMOJI_REPLACE_TEXT = '您输入了系统无法识别的表情字符，请更换'

const ERROR_TIPS_DEFAULT = '网络异常，请稍后再试'

const FETCH_ERROR_MAP = {
    'Network request failed': '网络未连接，请检查网络设置'
}

/**
 * 鉴权失败业务码（需清 token 并回登录页）
 * 501：旧接口；2010：未认证；2000/2007/2014：token 无效或过期
 * 不含 401：业务「参数验证错误」也用过 401，仅 HTTP 状态 401 视为未登录
 */
const AUTH_ERROR_CODES = [501, 2000, 2007, 2010, 2014, '501', '2000', '2007', '2010', '2014']

/** 避免并发请求同时触发多次跳转登录页 */
let unauthorizedHandling = false

/**
 * 判断接口是否成功
 * 旧: { error_code: 1, data }
 * 新: { code: 0, success: true, data }
 */
function _isApiSuccess(response) {
    if (!response) {
        return false
    }
    if (response.error_code == 1 || response.error_code == '1') {
        return true
    }
    if (response.code === 0 || response.code === '0') {
        return response.success !== false
    }
    return false
}

/** 判断接口是否成功（兼容旧 error_code 与新 code/success 格式） */
export function isApiSuccess(response) {
    return _isApiSuccess(response)
}

/** 获取接口错误信息（兼容 message / messages） */
export function getApiErrorMessage(response, fallback = ERROR_TIPS_DEFAULT) {
    return response?.message || response?.messages || fallback
}

/**
 * 判断是否为未登录 / token 失效
 * @param response {Object} 接口 JSON
 * @param httpStatus {number} HTTP 状态码，401 由资源服务器鉴权入口返回
 */
function _isApiUnauthorized(response, httpStatus) {
    if (httpStatus === 401) {
        return true
    }
    if (!response) {
        return false
    }
    if (response.error_code === 'errors.nologin') {
        return true
    }
    return AUTH_ERROR_CODES.some(code => code == response.code || code == response.error_code)
}

/**
 * token 失效时清本地登录态并回到登录页
 */
function handleUnauthorized() {
    if (unauthorizedHandling) {
        return
    }
    unauthorizedHandling = true
    store.dispatch(logout())
    Cookies.remove('TokenSign', getTokenCookieOptions())
    Cookies.remove('code', getTokenCookieOptions())
    if (window.location.pathname !== '/login') {
        window.location.replace('/login?loginType=phone&logout=force')
    }
}

/** 统一成功响应结构，保证调用方始终可通过 response.data 取业务数据 */
function _normalizeApiResponse(response, serverTime) {
    if (!response.data) {
        return {
            ...response,
            data: response,
            serverTimeOffset: serverTime - Date.now()
        }
    }
    return {
        ...response,
        serverTimeOffset: serverTime - Date.now()
    }
}

/** 从登录/注册接口响应中解析 token */
export function extractLoginToken(response) {
    if (!response) {
        return null
    }
    const data = response.data || response
    if (!data || typeof data !== 'object') {
        return null
    }
    return data.token || data.access_token || null
}

function _rejectApiError(response, reject) {
    if (_isApiUnauthorized(response)) {
        handleUnauthorized()
    }
    reject(response?.message || ERROR_TIPS_DEFAULT)
}

/** 获取鉴权请求头 */
function _getAuthHeaders() {
    const token = global.token
    if (isRightToken(token)) {
        return {Authorization: `Bearer ${token}`}
    }
    return {}
}

/** 所有请求统一携带的请求头 */
function _getCommonHeaders() {
    return {
        Lang: 'zh-CN',
        ..._getAuthHeaders()
    }
}

function _handleTooManyRequests(response, noPre, resolve, reject) {
    if (response && response.message === '当前操作人数过多请稍后再试') {
        setTimeout(() => {
            if (noPre) {
                resolve({
                    error_code: 'global.failed',
                    message: '活动太火爆了，请重试'
                })
            } else {
                reject('活动太火爆了，请重试')
            }
        }, rd(1, 5) * 1000)
        return true
    }
    return false
}

function _handleNoPreResponse(response, noPre, resolve, reject) {
    if (noPre == 'v2') {
        if (_isApiSuccess(response)) {
            resolve(response)
        } else if (_isApiUnauthorized(response)) {
            handleUnauthorized()
            reject(response.message)
        } else {
            reject(response)
        }
        return true
    }

    if (response && response.retCode == 'NPE000002') {
        getIPayInfo(global.token).then(iPayInfo => {
            store.dispatch(setIPayInfo(iPayInfo))
        })
    }
    resolve(response)
    return true
}

/**
 * 基于 fetch 封装的 GET请求
 * @param url
 * @param params
 * @param noPre - 不判断error_code
 * @returns {Promise}
 */
export function R_GET(url, params = {}, noPre) {
    return _FETCH(url, params, 'GET', noPre)
}

/**
 * 基于 fetch 封装的 POST请求
 * @param url
 * @param data
 * @param noPre
 * @returns {Promise}
 */
export function R_POST(url, data = {}, noPre) {
    return _FETCH(url, data, 'POST', noPre)
}

/**
 * fetch 封装
 * @param url
 * @param param
 * @param method
 * @param noPre - enum("v3",true)  v3:会更新服务器时间，true：直接resolve(response)
 * @returns {*}
 * @private
 */
function _FETCH(url, param = {}, method = 'GET', noPre = false) {
    if (url == undefined) {
        return Promise.reject('请求地址为空')
    }

    const params = {...param} // 避免修改入参param
    // 统一加上渠道接口
    // let channelMarketingCode = getValue('渠道', 'text')
    // try {
    //     params.channelMarketingCode = channelMarketingCode
    // } catch (e) {
    //     params = {channelMarketingCode}
    // }

    // 统一加上统计信息
    // try {
    //     params.TRU = global.__userId || 0 //当前用户id
    //     params.TREF = global.__prevPageName || "init" //调用的页面之前页面
    //     params.TFROM = global.__nowPageName || "init" //调用的页面
    //
    // } catch (e) {
    // }

    return new Promise(function(resolve, reject) {
        let settled = false
        const timeoutId = setTimeout(() => {
            if (!settled) {
                settled = true
                reject('网络请求超时，请检查网络设置')
            }
        }, TIMEOUT)

        const finishResolve = value => {
            if (settled) {
                return
            }
            settled = true
            clearTimeout(timeoutId)
            resolve(value)
        }

        const finishReject = error => {
            if (settled) {
                return
            }
            settled = true
            clearTimeout(timeoutId)
            reject(error)
        }

        if (global.token === 'logout') {
            finishReject('已退出登录')
            return
        }

        function _fetch() {
            // 鉴权走 Authorization 请求头，不再自动拼 token / xxl_sso_sessionid 到 query/body
            let headerData = {}
            if (params.headers) {
                headerData = params.headers
                delete params.headers
            }
            let requestBody = qs.stringify(params)

            if (requestBody.match(encodeURIComponent(EMOJI_REPLACE_TEXT)) !== null) {
                // 判断是否有参数值为 纯emoji
                return finishReject(EMOJI_REPLACE_TEXT)
            }

            requestBody = qs.parse(requestBody)

            requestBody = qs.stringify(requestBody, { arrayFormat: 'repeat' })
            if (Object.keys(headerData).length) {
                requestBody = JSON.stringify(params)
            }
            let responseStatus = 200
            let fetch_url = url
            // authorize(
            //     function(credential) {
            const signatureHeader = 'X-Baie-Authorization'

            let fetch_param = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'User-Agent': USER_AGENT,
                    ..._getCommonHeaders(),
                    ...headerData
                },
                body: requestBody
            }

            if (noPre === 'authorize') {
                fetch_param = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'User-Agent': USER_AGENT,
                        ..._getCommonHeaders(),
                        ...headerData
                        // [signatureHeader]: credential
                    },
                    body: JSON.stringify(params)
                }
            }

            if (method === 'GET') {
                if (fetch_url.search(/\?/) === -1) {
                    fetch_url += `?${requestBody}`
                } else {
                    fetch_url += `&${requestBody}`
                    requestBody = fetch_url.split('?')[1] + requestBody // fetch_url 本身有参数的话，也需要参与签名，不过这是不规范的用法
                }
                fetch_param = {
                    method: 'GET',
                    credentials: 'omit',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'text/plain',
                        'User-Agent': USER_AGENT,
                        ..._getCommonHeaders(),
                        ...headerData
                        // [signatureHeader]: credential
                    }
                }
            }

            let serverTime = Date.now()
            fetch(fetch_url, fetch_param)
                .then(response => {
                    try {
                        serverTime = response.headers.map.date[0]
                        global.__serverTime = response.headers.map.date[0]
                    } catch (e) {}
                    responseStatus = response.status
                    return response.json().then(
                        body => {
                            return {body, status: response.status}
                        },
                        () => {
                            return {body: null, status: response.status}
                        }
                    )
                })
                .then(({body, status}) => {
                    if (_isApiUnauthorized(body, status)) {
                        handleUnauthorized()
                        finishReject((body && body.message) || '登录已过期，请重新登录')
                        return
                    }

                    if (_handleTooManyRequests(body, noPre, finishResolve, finishReject)) {
                        return
                    }

                    if (noPre) {
                        _handleNoPreResponse(body, noPre, finishResolve, finishReject)
                        return
                    }

                    if (_isApiSuccess(body)) {
                        finishResolve(_normalizeApiResponse(body, serverTime))
                    } else {
                        finishReject((body && body.message) || ERROR_TIPS_DEFAULT)
                    }
                })
                .catch(err => {
                    captureException(err)
                    if (noPre === 'v3') {
                        try {
                            global.__serverTime = 0
                        } catch (e) {}
                    }
                    if (responseStatus === 401) {
                        handleUnauthorized()
                        finishReject('登录已过期，请重新登录')
                        return
                    }
                    const errMsg = _parseErrorMsg(err, responseStatus)
                    finishReject(errMsg)
                })
            // },
            // params,
            // {arrayFormat: 'repeat'}
            // )
        }
        _fetch()
    })
}

/**
 * fetch for cms
 * @param url
 * @param params
 * @param noPre - enum("v3",true)  v3:会更新服务器时间，true：直接resolve(response)
 * @returns {*}
 * @private
 */
export function R_GET_CMS(url, params = {}) {
    if (url == undefined) {
        return Promise.reject('请求地址为空')
    }
    return new Promise(function(resolve, reject) {
        setTimeout(() => {
            reject('网络请求超时，请检查网络设置')
        }, TIMEOUT)

        _fetch()

        function _fetch() {
            const requestBody = qs.stringify(params)

            let fetch_url = url
            const fetch_param = {
                method: 'GET',
                credentials: 'omit',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'text/plain',
                    ..._getCommonHeaders()
                }
            }

            if (fetch_url.search(/\?/) === -1) {
                fetch_url += `?${requestBody}`
            } else {
                fetch_url += `&${requestBody}`
            }

            fetch(fetch_url, fetch_param)
                .then(response => {
                    try {
                        global.__serverTime = response.headers.map.date[0]
                    } catch (e) {}
                    return response.json()
                })
                .then(response => {
                    traceResponseError(response)
                    if (_isApiSuccess(response) || !response.error_code) {
                        // cms 接口可能没有 error_code；新网关走 code === 0
                        resolve(response)
                    } else {
                        reject(response?.message || ERROR_TIPS_DEFAULT)
                    }
                })
                .catch(err => {
                    captureException(err)
                    reject(ERROR_TIPS_DEFAULT)
                })
        }
    })
}

/**
 * 处理错误信息
 * @param err
 * @returns {*}
 * @private
 */
function _parseErrorMsg(err, status = 200) {
    let errText = err
    if (errText && errText.message) {
        errText = errText.message
    }
    if (FETCH_ERROR_MAP[errText]) {
        errText = FETCH_ERROR_MAP[errText]
    }

    if (errText && errText.match) {
        if (errText.match('Uncaught SyntaxError') != null) {
            errText = ERROR_TIPS_DEFAULT
        }
        if (errText.match('Unexpected token') != null) {
            errText = ERROR_TIPS_DEFAULT
        }
        if (errText.match('JSON Parse error') != null) {
            errText = ERROR_TIPS_DEFAULT
        }
        if (errText.match('timeout') != null) {
            errText = ERROR_TIPS_DEFAULT
        }
        if (errText.match('Failed to fetch') != null) {
            errText = ERROR_TIPS_DEFAULT
        }
    }

    if (typeof errText === 'object') {
        errText = JSON.stringify(errText)
    }
    return errText
}

function removeEmoji(str, params) {
    if (params && params.__emoji) {
        return str
    }
    if (str && str.replace) {
        let newStr = str.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/gm, '') // 替换 emoji 表情
        if (newStr == '') {
            newStr = EMOJI_REPLACE_TEXT
        }
        return newStr
    }
    return str
}

/**
 * 将后端 companyAccount 转为布尔值
 * @param {boolean|number|string|undefined} flag 公司账户标识
 * @returns {boolean} 是否公司账户
 */
function toCompanyAccountFlag(flag) {
    return flag === true || flag === 1 || flag === '1'
}

/**
 * 是否公司账户（登录经销商端时拦截订货/补单/收货，发货列表不展示库存）
 * @param {object} userInfo 登录用户信息
 * @returns {boolean} 是否公司账户
 */
export function isCompanyAccount(userInfo) {
    if (!userInfo) {
        return false
    }
    return toCompanyAccountFlag(userInfo.companyAccount)
}

/**
 * 将 getInfo 接口返回的数据统一映射为前端 userInfo 结构
 * 新网关: { market: { userId, ... }, userDesc, isSubstitution, companyAccount, ... }
 * 旧接口: { userId, username, rankNum, ... } 平铺在 data 上
 */
export function normalizeMarketerUserInfo(raw = {}) {
    const market = raw.market || {}
    const userId = market.userId || raw.userId
    const username = market.username || raw.username
    const phone = market.phone || raw.phone
    const imgUrl = market.imgUrl || raw.imgUrl
    const rankNum = market.rankNum ?? raw.rankNum ?? market.capacityId ?? raw.capacityId ?? 1
    const userEpithetId = raw.userEpithetId ?? market.userEpithetId ?? market.capacityId ?? raw.capacityId ?? 0

    const result = {
        ...market,
        ...raw,
        userId,
        username,
        userName: username,
        mobile: phone || raw.mobile || market.mobile,
        avatar: imgUrl,
        imgUrl,
        rankNum,
        grade: rankNum,
        userEpithetId,
        numberDesc: raw.numberDesc ?? market.numberDesc,
        userDesc: raw.userDesc ?? market.userDesc,
        isSubstitution: raw.isSubstitution ?? market.isSubstitution ?? 0,
        companyAccount: toCompanyAccountFlag(raw.companyAccount ?? market.companyAccount),
        capacityId: market.capacityId ?? raw.capacityId,
        trainFeeExpireTime: raw.trainFeeExpireTime || market.trainFeeExpireTime,
        ramarkJSON: raw.ramarkJSON ?? market.ramarkJSON,
        status: raw.status ?? market.status,
        wechat: raw.wechat ?? market.wechat,
        realName: raw.realName ?? market.realName,
        sellerId: raw.sellerId ?? market.sellerId,
        bankCode: raw.bankCode ?? market.bankCode,
        disabled: raw.disabled ?? market.disabled,
        numberCode: raw.numberCode ?? market.numberCode,
        openId: raw.openId ?? market.openId,
        expireTime: raw.expireTime ?? market.expireTime,
        email: market.email || raw.email,
        bindEmail: market.bindEmail ?? raw.bindEmail
    }
    delete result.market

    for (const key in result) {
        if (result[key] === null) {
            result[key] = ''
        }
    }
    return result
}

export function getUserInfo(token = false) {
    return new Promise(function(resolve, reject) {
        if (!isRightToken(global.token) && !isRightToken(token)) {
            reject('请先登录')
            return
        }
        const tokenParam = {}
        if (token) {
            tokenParam.token = token
        }
        Promise.all([
            R_GET(USER_INFO)
            // getNewWalletInfo(tokenParam),
            // R_GET(I_GET_EPITHID, tokenParam) // iEnglish用户等级
        ])
            .then(response => {
                const normalized = normalizeMarketerUserInfo(response[0].data)
                const {
                    userId,
                    username,
                    imgUrl,
                    rankNum,
                    status,
                    wechat,
                    phone,
                    realName,
                    sellerId,
                    bankCode,
                    disabled,
                    numberCode,
                    numberDesc,
                    userDesc,
                    mobile,
                    openId,
                    expireTime,
                    capacityId,
                    trainFeeExpireTime,
                    userEpithetId,
                    isSubstitution,
                    companyAccount,
                    ramarkJSON
                } = normalized

                if (!userId) {
                    reject('用户信息获取失败')
                    return
                }

                if (disabled === true) {
                    global.token = 'logout'
                    reject('账号已被冻结，请联系客服')
                    return
                }
                let grade = rankNum
                if (status === '审核中') {
                    grade = ''
                }
                if (status === '审核成功' && rankNum == 0) {
                    grade = 1
                }

                const result = {
                    userId,
                    userName: username,
                    avatar: imgUrl,
                    grade,
                    wechat,
                    mobile: mobile || phone,
                    realName,
                    status,
                    sellerId,
                    bankCode,
                    numberCode,
                    numberDesc,
                    userDesc,
                    openId,
                    expireTime,
                    capacityId,
                    trainFeeExpireTime,
                    userEpithetId,
                    isSubstitution,
                    companyAccount,
                    ramarkJSON
                }
                for (const key in result) {
                    if (result[key] === null) {
                        result[key] = ''
                    }
                }

                // console.log('result')
                // console.log(result)

                // // 给老web用
                // syncCookie('grade', rankNum)
                // syncCookie('status', status)
                // syncCookie('avatar', imgUrl)
                // syncCookie('realName', realName)
                // syncCookie('shopSellerId', sellerId)
                // syncCookie('userSignId', userId)
                // syncCookie('userName', username)
                // syncCookie('isTFS', walletNew.channel === 'TFS' ? 'YES' : 'NO')
                //
                // // 诸葛身份识别
                // identify(`${userId}`, {
                //     userName: `${username}`,
                //     avatar: `${imgUrl}`,
                //     grade: `${userEpithetId}`, // iEnglish用户等级
                //     wechat: `${wechat}`,
                //     mobile: `${phone}`,
                //     realName: `${realName}`,
                //     status: `${status}`,
                //     sellerId: `${sellerId}`
                // })
                //
                // setSentryUser({id: userId, username})
                // setSentryTag('user_grade', userEpithetId)
                //
                resolve(result)
            })
            .catch(reject)
    })

    function logout(token) {
        R_POST(LOGOUT_URL, {token}).catch(() => {})
    }

    function getWalletInfo(tokenParam) {
        // 这个工具函数的作用是判断易宝支付的开户情况
        return new Promise(function(resolve, reject) {
            R_GET(USER_WALLET_INFO, tokenParam)
                .then(response => {
                    resolve(response)
                })
                .catch(e => {
                    resolve({data: {status: '获取信息失败'}})
                })
        })
    }

    /**
     * 分账通信息
     * @param tokenParam
     * @returns {Promise}
     */
    function getNewWalletInfo(tokenParam) {
        return new Promise(function(resolve, reject) {
            R_GET(NEW_WALLET_INFO_QUERY, tokenParam)
                .then(response => {
                    resolve(response)
                })
                .catch(e => {
                    resolve({data: {status: '获取信息失败', channel: 'TFS', ifIdCardType: true}})
                })
        })
    }

    /**
     * 是否微商团队
     * @param tokenParam
     * @returns {Promise}
     */
    function getWSInfo(tokenParam) {
        return new Promise(function(resolve, reject) {
            R_GET(MARKETER_WSTEAM_GET, tokenParam)
                .then(response => {
                    resolve(response.data?.ifWsTeam ?? response.ifWsTeam)
                })
                .catch(e => {
                    resolve(false)
                })
        })
    }

    /**
     * 是否星探信息
     * @param tokenParam
     * @returns {Promise}
     */
    function getStarInfo(tokenParam) {
        return new Promise(function(resolve, reject) {
            R_GET(MARKETER_USERINFO_GET, tokenParam)
                .then(response => {
                    // resolve(true)
                    resolve(response.data)
                })
                .catch(e => {
                    resolve({})
                })
        })
    }
}

export function getIPayInfo(token = false) {
    return null
    return new Promise(function(resolve, reject) {
        if (!isRightToken(global.token) && !isRightToken(token)) {
            reject('请先登录')
            return
        }
        const tokenParam = {}
        if (token) {
            tokenParam.token = token
        }
        console.log(tokenParam)
        Promise.all([R_GET(ORDER_WEB_ORDERS_PAYMENT_SIGN, tokenParam, 'authorize')])
            .then(response => {
                let {userToken} = response[0]

                const result = {
                    userToken
                }
                for (const key in result) {
                    if (result[key] === null) {
                        result[key] = ''
                    }
                }
                resolve(result)
            })
            .catch(reject)
    })
}

function syncCookie(key, value) {
    Cookies.set(key, value, {expires: 365, domain: getMainDomain(window.location.hostname)})
}

/**
 * url跳转
 * noreferrer--防止风控
 */
export function noRefOpen(href) {
    window.location.replace(href)
    // var temp=document.createElement("a")
    // temp.setAttribute("rel","noreferrer")
    // temp.setAttribute("href",href)
    // temp.click()
}

/**
 * JS获取n至m随机整数
 */
function rd(n, m) {
    const c = m - n + 1
    return Math.floor(Math.random() * c + n)
}

/**
 * 替换页面参数
 * @param newState
 */
export function replacePageUrlParam(newState) {
    const keys = Object.keys(newState)
    const params = keys.map(key => `${key}=${newState[key]}`)
    history.replaceState(newState, '', keys.length > 0 ? `?${params.join('&')}` : '')
}
